import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { IMultiSelectOption } from '~/pages/anatomyV2/libs/components/MultiSelectQuestionTemplate/constants'
import { MultiSelectQuestionTemplateStyles as S } from '~/pages/anatomyV2/libs/components/MultiSelectQuestionTemplate/styles'
import SectionProgress from '~/pages/anatomyV2/libs/components/SectionProgress'
import { useMatchHeaderBackground } from '~/pages/anatomyV2/libs/hooks/useMatchHeaderBackground'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

interface IMultiSelectQuestionTemplateProps extends TPageProps {
  currentSection: number
  titleI18nKey: string
  options: IMultiSelectOption[]
  question: string
}

const MultiSelectQuestionTemplate = ({
  pageId,
  nextPagePath,
  currentSection,
  titleI18nKey,
  options,
  question,
}: IMultiSelectQuestionTemplateProps) => {
  useMatchHeaderBackground()

  const { t } = useTranslation('anatomyV2')
  const [answers, setAnswers] = useState<string[]>([])

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question,
  })

  const handleOptionToggle = (key: string) => {
    setAnswers((prev) =>
      prev.includes(key)
        ? prev.filter((answer) => answer !== key)
        : [...prev, key],
    )
  }

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.ProgressWrapper>
          <SectionProgress currentSection={currentSection} pageId={pageId} />
        </S.ProgressWrapper>

        <S.ScrollContent>
          <S.Title>
            <Trans ns="anatomyV2" i18nKey={titleI18nKey} />
          </S.Title>

          <S.Options>
            {options.map(({ key, emoji, i18nKey }) => {
              const isSelected = answers.includes(key)

              return (
                <S.OptionButton
                  key={key}
                  type="button"
                  $isSelected={isSelected}
                  onClick={() => handleOptionToggle(key)}
                >
                  <S.OptionEmoji>{emoji}</S.OptionEmoji>
                  <S.OptionLabel>{t(i18nKey)}</S.OptionLabel>
                  <S.Checkbox $isSelected={isSelected} />
                </S.OptionButton>
              )
            })}
          </S.Options>
        </S.ScrollContent>

        <S.ButtonWrapper>
          <S.StyledButton
            type="button"
            disabled={!answers.length}
            onClick={() => handleContinue(answers)}
          >
            <Trans i18nKey="actions.continue" />
          </S.StyledButton>
        </S.ButtonWrapper>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default MultiSelectQuestionTemplate
